var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntBilling({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.84615C2 5.72198 3.72198 4 5.84615 4H18.1538C20.278 4 22 5.72198 22 7.84615V16.0513C22 18.1755 20.278 19.8974 18.1538 19.8974H5.84615C3.72198 19.8974 2 18.1755 2 16.0513V7.84615ZM3.53846 10.6667V16.0513C3.53846 17.3258 4.57165 18.359 5.84615 18.359H18.1538C19.4284 18.359 20.4615 17.3258 20.4615 16.0513V10.6667H3.53846ZM20.4615 9.12821H3.53846V7.84615C3.53846 6.57165 4.57165 5.53846 5.84615 5.53846H18.1538C19.4283 5.53846 20.4615 6.57165 20.4615 7.84615V9.12821ZM6.10256 15.0256C6.10256 14.6008 6.44696 14.2564 6.8718 14.2564H7.89744C8.32227 14.2564 8.66667 14.6008 8.66667 15.0256C8.66667 15.4505 8.32227 15.7949 7.89744 15.7949H6.8718C6.44696 15.7949 6.10256 15.4505 6.10256 15.0256ZM11.2308 15.0256C11.2308 14.6008 11.5752 14.2564 12 14.2564H13.0256C13.4505 14.2564 13.7949 14.6008 13.7949 15.0256C13.7949 15.4505 13.4505 15.7949 13.0256 15.7949H12C11.5752 15.7949 11.2308 15.4505 11.2308 15.0256Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntBilling);
export default __webpack_public_path__ + "static/media/ent-billing.cb384de8d89dd1f155dd3240d4029616.svg";
export { ForwardRef as ReactComponent };